import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import env from '@jwp/ott-common/src/env';

type MenuItem = {
  to: string;
  label: string;
  target: string | undefined;
};

export const useMenuItemsCustom = () => {
  const { i18n } = useTranslation();

  return useMemo(() => {
    return (env.APP_CUSTOM_USER_LINKS || []).reduce<[MenuItem[], MenuItem[]]>(
      ([before, after], link) => {
        (link.position === 'before' ? before : after).push({
          to: link.link,
          label: link?.translations?.[i18n.language] ?? link.title,
          target: link.link.startsWith('http') ? '_blank' : undefined,
        });
        return [before, after];
      },
      [[], []],
    );
  }, [i18n.language]);
};
